interface CommonTwitchLinkProps {
  href: string;
  label: string;
  className?: string;
}

export const CommonTwitchLink = ({ href, label, className = "" }: CommonTwitchLinkProps) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`inline-flex max-w-full min-w-0 items-center justify-center text-center font-shentox font-semibold tracking-[0.06em] uppercase whitespace-normal text-light-blue no-underline transition-[opacity,text-decoration-color] duration-200 hover:opacity-85 hover:underline hover:underline-offset-2 ${className}`}
  >
    {label}
  </a>
);
